import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

import MainLayout from '~/pages/_layouts/main';

function RouteWrapper({ component: Component, ...rest }) {
    const Layout = MainLayout;

    return (
        <Route
            {...rest}
            render={props => (
                <Layout>
                    <Component {...props} />
                </Layout>
            )}
        />
    );
}

RouteWrapper.propTypes = {
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
        .isRequired,
};

export default RouteWrapper;
